var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"rules":[_vm.rules.zipcode],"label":_vm.label,"maxlength":5},on:{"keypress":_vm.validateKey},model:{value:(_vm.textValue),callback:function ($$v) {_vm.textValue=$$v},expression:"textValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }